export const getUserDisplayName = (user) => !!user ? user.name || user.email : null



// WEBPACK FOOTER //
// ./src/scripts/app/modules/user/utils.js